import { render, staticRenderFns } from "./NoticeBox.vue?vue&type=template&id=34b721b1&scoped=true&"
import script from "./NoticeBox.vue?vue&type=script&lang=ts&"
export * from "./NoticeBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b721b1",
  null
  
)

export default component.exports